module.exports = __webpack_public_path__ + "static/media/bg_03.64e2c090.jpg";